import { render, staticRenderFns } from "./ManualPayment.vue?vue&type=template&id=03024867&"
import script from "@/scripts/payment/manualPayment.js?vue&type=script&lang=js&"
export * from "@/scripts/payment/manualPayment.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports